import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    card: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: 20,
        backgroundColor: theme.palette.background.paper,
        borderColor: theme.palette.secondary.main,
        border: 'solid 1px'
    },
    cardIcon: {
        width: 80,
        margin: 20
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    line: {
        color: theme.palette.text.secondary,
        fontSize: 16,
        marginTop: 10
    }
}));

export {useStyles};